import { PropositionDetails } from "@dune/types";
import { DataTable } from "@dune/ui";
import { useNavigate } from "react-router-dom";
import { useReceiptsByPropositionQuery } from "../../../../api/queries/receipt.queries";
import { receiptColumns } from "../../../receipts/data-table/receipt-columns";
import CreateReceiptModal from "../modals/CreateReceiptModal";
import { useMe } from "../../../../api/queries/users.queries";
import { match } from "ts-pattern";

interface ReceiptsTabProps {
	proposition: PropositionDetails;
}

const ReceiptsTab = ({ proposition }: ReceiptsTabProps) => {
	const navigate = useNavigate();
	const { me } = useMe();

	const { data: receipts = [], isLoading } = useReceiptsByPropositionQuery(
		proposition.id,
	);

	return (
		<div className="h-full">
			<div className="flex items-center justify-between mb-2 w-full">
				<h2 className="text-lg text-text-main-blue font-semibold">
					Quittances
				</h2>
				{match(me)
					.with({ role: "DUNE" }, () => (
						<CreateReceiptModal proposition={proposition} />
					))
					.otherwise(() => undefined)}
			</div>
			<DataTable
				data={receipts}
				columns={receiptColumns}
				noResultsText="Aucune quittance trouvée"
				isLoading={isLoading}
				onRowClick={(row) => navigate(`/receipts/${row.id}`)}
			/>
		</div>
	);
};

export { ReceiptsTab };
